import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface MarketingNavContextValue {
  open: boolean;
  openNav: () => void;
  closeNav: () => void;
  toggleNav: () => void;
}

const MarketingNavContext = createContext<MarketingNavContextValue>({
  open: false,
  openNav: () => {},
  closeNav: () => {},
  toggleNav: () => {},
});

export function MarketingNavProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const openNav = useCallback(() => setOpen(true), []);
  const closeNav = useCallback(() => setOpen(false), []);
  const toggleNav = useCallback(() => setOpen((v) => !v), []);

  const value = useMemo(
    () => ({ open, openNav, closeNav, toggleNav }),
    [open, openNav, closeNav, toggleNav],
  );

  return (
    <MarketingNavContext.Provider value={value}>
      {children}
    </MarketingNavContext.Provider>
  );
}

export function useMarketingNav() {
  return useContext(MarketingNavContext);
}
